export enum CommunicationModeEnum {
    SignalR = 1,
    WebAPI = 2,
    HybridRelay = 3
}

export enum SearchResultTableEnum {
    Pharmacy = 0,
    AzureAccount = 1,
    AzureEndpoint = 2,
    AzureNamespace = 3,
    PharmacyGroup = 4,
    User = 5
}